import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import MedRecordCategoryForm from './MedRecordCategoryForm';

const MedRecordCategoryModal = ({ show, onHide, medrecval, edittrigger, onCallParent }) => {
    const isEdit = Boolean(medrecval && (medrecval.category_id || medrecval.mc_id || medrecval.id));

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Medical Record Category' : 'Add Medical Record Category'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <MedRecordCategoryForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    medrecval={medrecval}
                />
            </Modal.Body>
        </Modal>
    );
};

MedRecordCategoryModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    medrecval: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default MedRecordCategoryModal;
